import React, { useContext } from 'react'
import CardContext from 'context/card'

const Badges = () => {
    const props = useContext(CardContext)    
    const { product } = props
    const badgeList = product ? product?.badgeList : props.badgeList
    
    if(!badgeList || !badgeList.length) return
    return(
        <div
            style={{ top: 12, left: 12 }}
            className='p-absolute d-flex g-2'
        >
            {badgeList.map((badge, i) => {
                const { text, color } = badge
                
                return <span
                    key={`${text}-${color}-${i}`}
                    className='badge'
                    style={{ background: color }}
                >
                    {text}
                </span>
            })}
        </div>
    )
}

export default Badges